import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Filter } from '../interfaces/filter.interface';
import { Shift } from '../interfaces/shift.interface';
import { CloseShift } from '../interfaces/close-shift';

@Injectable({
    providedIn: 'root',
})
export class ShiftService {
    private baseUrl = environment.apiBaseUrl;

    constructor(private http: HttpClient) { }

    getShift(id: number): Observable<any> {
        return this.http.get(`${this.baseUrl}/Shift/${id}`);
    }

    listShift(pageNumber = 1, pageSize = 10, term = '', filters?: Filter[]): Observable<any> {
        const params = {
            pageNumber,
            pageSize,
            term,
            advancedFilter: filters,
        };
        return this.http.post(`${this.baseUrl}/Shift/List`, params);
    }

    createShift(data: Shift): Observable<any> {
        return this.http.post(`${this.baseUrl}/Shift`, data);
    }

    updateShift(data: Shift): Observable<any> {
        return this.http.put(`${this.baseUrl}/Shift`, data);
    }

    deleteShift(id: number): Observable<any> {
        return this.http.delete(`${this.baseUrl}/Shift/${id}`);
    }

    getCurrentShift(isCachable = false): Observable<any> {
        const header = isCachable ? { headers: { 'X-Use-Cache': 'true' } } : {};
        return this.http.get(`${this.baseUrl}/Shift/current`, header);
    }

    closeShift(data: CloseShift): Observable<any> {
        return this.http.post(`${this.baseUrl}/Shift/Close`, data);
    }

    getSummery(shiftId: string): Observable<any> {
        return this.http.get(`${this.baseUrl}/Shift/${shiftId}/Summary`);
    }

    settlement(shiftId: string): Observable<any> {
        return this.http.post(`${this.baseUrl}/Shift/${shiftId}/settlement`, {});
    }
}